<template>  
  <div>
    <router-view  />
  </div>  
</template>

<script>


export default {
  name: 'App',
  watch: {
    $route() {      
      console.log('app watch route')
        /* window.dataLayer.push({
          'event': 'eventNavigation',
          'category': '',
          'action': '',
          'label': ''
        });   */
        window.dataLayer.push('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-9373807/soproni/2024_0+standard'
      });
    }
  },
  created()  {
    //get the promo status - before, live, after    
        /*this.get('info/status',{})
        .then((resp) => {
          this.$store.state.promoStatus = resp.data.promo_status                    
          this.$store.state.loginShow = resp.data.promo_login_status     
        }).catch((err) => {
            console.log(err)
        })*/

       
        this.$store.dispatch("getSettings");
        this.$store.dispatch("getFileUrl")

        
  }
}
</script>